import { Injectable } from '@angular/core';

import { Stage } from '../models';
import { AppState } from '../app-state';

import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import { StageDoc, stagePullQueryBuilder, stageSchema } from '../schema/stage-schema';


@Injectable({ providedIn: 'root' })
export class StageService extends TestbedRxdbGraphQlCollectionService<Stage,StageDoc>{

    constructor( appState : AppState, authService: AuthenticationService, rxdbState: TestbedRxdbState ) {
        super('stage', stageSchema, appState, rxdbState, authService)
        this.syncConfig = {
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.stage.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: stagePullQueryBuilder(),
            graphQLSubscription: 
            `subscription{
                stageUpdated{
                    stages{
                        name
                    }
                }
            }`        
        }
    }
}